// Shared money/format primitives for the cost-control dashboards (Financial Control,
// Ownership & Accountability, …). One implementation so every tab formats euros, percentages,
// and status tones identically. No React here.

// humanEUR formats a euro amount compactly, scaling through k / M / B so large figures never
// render as "€10000k". One decimal below 10 of a unit (e.g. €1.2M), rounded above it (e.g. €31k).
export function humanEUR(v) {
  const n = Number(v) || 0;
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs < 1000) return `€${sign}${Math.round(abs)}`;
  const tiers = [
    [1e9, "B"],
    [1e6, "M"],
    [1e3, "k"],
  ];
  for (const [divisor, suffix] of tiers) {
    if (abs >= divisor) {
      const u = abs / divisor;
      const s = u < 10 ? u.toFixed(1).replace(/\.0$/, "") : String(Math.round(u));
      return `€${sign}${s}${suffix}`;
    }
  }
  return `€${sign}${Math.round(abs)}`;
}

// pct renders a 0–1 fraction as a whole-number percentage.
export function pct(n) {
  return `${Math.round((Number(n) || 0) * 100)}%`;
}

// statusTone maps the backend's green/amber/red status to a UI tone key.
export function statusTone(status) {
  switch (status) {
    case "green":
      return "ok";
    case "amber":
      return "attention";
    case "red":
      return "critical";
    default:
      return "neutral";
  }
}

// worstTone returns the more severe of two tones (neutral/ok < attention < critical), so a single
// fact whose severity is computed from several signals never shows two contradicting colours.
const TONE_RANK = { neutral: 0, ok: 0, attention: 1, critical: 2 };
export function worstTone(a, b) {
  return (TONE_RANK[b] || 0) > (TONE_RANK[a] || 0) ? b : a;
}
